import type { LucideIcon } from "lucide-react";
import {
  CalendarDays,
  CalendarPlus,
  ListChecks,
  Mail,
  MessageSquare,
  UsersRound,
} from "lucide-react";

export interface CreateAction {
  /** What is being started, as it reads after the word "New". */
  label: string;
  icon: LucideIcon;
  /** The screen that owns the dialog, or the form itself. */
  to: string;
  /**
   * The note left for that screen, saying which of its dialogs to open.
   * Left out when the address is the form already. See `lib/create.ts`.
   */
  ask?: string;
  /** Other words somebody might type for it in the search box. */
  keywords?: string;
  /** Only for somebody holding a manager's position. */
  managerOnly?: boolean;
}

/**
 * What can be started from anywhere.
 *
 * One button in the top bar does this, because the thing
 * somebody wants to start is rarely on the screen they happen to be on.
 * Only things that are a dialog or a form: a list somebody would have to
 * search first is a screen, and screens are in the sidebar.
 */
export const ADMIN_CREATE: CreateAction[] = [
  { label: "Letter", icon: Mail, to: "/admin/letters", ask: "letter", keywords: "warning certificate write" },
  { label: "Task", icon: ListChecks, to: "/admin/work", ask: "task", keywords: "assign todo" },
  { label: "Meeting", icon: CalendarPlus, to: "/admin/work", ask: "meeting", keywords: "invite" },
  { label: "Message", icon: MessageSquare, to: "/admin/chat", ask: "message", keywords: "chat write" },
  { label: "Chat group", icon: UsersRound, to: "/admin/chat", ask: "group", keywords: "channel" },
];

export const EMPLOYEE_CREATE: CreateAction[] = [
  { label: "Leave request", icon: CalendarDays, to: "/leaves/new", keywords: "holiday annual sick" },
  { label: "Letter request", icon: Mail, to: "/documents", ask: "letter-request", keywords: "certificate noc ask" },
  { label: "Task", icon: ListChecks, to: "/work", ask: "task", keywords: "assign todo", managerOnly: true },
  { label: "Meeting", icon: CalendarPlus, to: "/work", ask: "meeting", keywords: "invite", managerOnly: true },
  { label: "Message", icon: MessageSquare, to: "/chat", ask: "message", keywords: "chat write" },
];
